var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"wbot-icon",attrs:{"src":require("@/assets/images/wbot.svg")},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }